module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-3.e0614c5d.svg";